import { createContext, useContext } from "react";

interface MaintenanceContextValue {
  showBanner: boolean;
  bannerText: string;
}

const MaintenanceContext = createContext<MaintenanceContextValue>({
  showBanner: false,
  bannerText: ""
});

export const useMaintenanceContext = () => useContext(MaintenanceContext);

export default MaintenanceContext;
